import React,  { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Experience from '../../../components/Career/Experience/Experience';
import Education from '../../../components/Career/Education/Education';
import SkillsContainer from '../../../components/Career/Skills/SkillsContainer';
import CredentialsContainer from '../../../components/Career/Credentials/CredentialsContainer';
import CareerMedia from '../../../components/Career/CareerMedia/CareerMedia';
import Resume from '../../../components/Career/Resume/Resume';



const ProfileContainer = ({username, about, t, appData, setAppData}) => {

    const [activeTab, setActiveTab] = useState('About');
    return (
        <>

            <div
                data-current="Tab 1"
                data-easing="ease"
                data-duration-in={300}
                data-duration-out={100}
                className="public-profile-inner-tab-block w-tabs"
            >
                <div
                    className="public-profile-inner-tabs-menu w-tab-menu"
                    role="tablist"
                >
                    <NavLink
                        data-w-tab="Tab 1"
                        className={`public-profile-inner-tabs-menu-link w-inline-block w-tab-link ${activeTab === 'About' ? 'w--current' : ''}`}
                        id="w-tabs-0-data-w-tab-0"
                        to="#w-tabs-0-data-w-pane-0"
                        role="tab"
                        aria-controls="w-tabs-0-data-w-pane-0"
                        aria-selected={activeTab === 'About'}
                        onClick={() => setActiveTab('About')}
                    >
                        <div className="prof_menu no-hover">About</div>
                    </NavLink>

                    <NavLink
                        data-w-tab="Tab 1"
                        className={`public-profile-inner-tabs-menu-link w-inline-block w-tab-link ${activeTab === 'Education' ? 'w--current' : ''}`}
                        id="w-tabs-0-data-w-tab-0"
                        to="#w-tabs-0-data-w-pane-0"
                        role="tab"
                        aria-controls="w-tabs-0-data-w-pane-0"
                        aria-selected={activeTab === 'Education'}
                        onClick={() => setActiveTab('Education')}
                    >
                        <div className="prof_menu no-hover">Education</div>
                    </NavLink>

                    <NavLink
                        data-w-tab="Tab 2"
                        className={`public-profile-inner-tabs-menu-link w-inline-block w-tab-link ${activeTab === 'Experience' ? 'w--current' : ''}`}
                        tabIndex={-1}
                        id="w-tabs-0-data-w-tab-1"
                        to="#w-tabs-0-data-w-pane-1"
                        role="tab"
                        aria-controls="w-tabs-0-data-w-pane-1"
                        aria-selected={activeTab === 'Experience'}
                        onClick={() => setActiveTab('Experience')}
                    >
                        <div className="prof_menu no-hover">Experience</div>
                    </NavLink>
                    <NavLink
                        data-w-tab="Tab 4"
                        className={`public-profile-inner-tabs-menu-link w-inline-block w-tab-link ${activeTab === 'Skills' ? 'w--current' : ''}`}
                        tabIndex={-1}
                        id="w-tabs-0-data-w-tab-2"
                        to="#w-tabs-0-data-w-pane-2"
                        role="tab"
                        aria-controls="w-tabs-0-data-w-pane-2"
                        aria-selected={activeTab === 'Skills'}
                        onClick={() => setActiveTab('Skills')}
                    >
                        <div className="prof_menu no-hover">Skills</div>
                    </NavLink>
                    <NavLink
                        data-w-tab="Tab 5"
                        className={`public-profile-inner-tabs-menu-link w-inline-block w-tab-link ${activeTab === 'Credentials' ? 'w--current' : ''}`}
                        tabIndex={-1}
                        id="w-tabs-0-data-w-tab-3"
                        to="#w-tabs-0-data-w-pane-3"
                        role="tab"
                        aria-controls="w-tabs-0-data-w-pane-3"
                        aria-selected={activeTab === 'Credentials'}
                        onClick={() => setActiveTab('Credentials')}
                    >
                        <div className="prof_menu no-hover">Credentials</div>
                    </NavLink>

                    <NavLink
                  data-w-tab="Tab 3"
                  className={`public-profile-inner-tabs-menu-link w-inline-block w-tab-link ${activeTab === 'Resume' ? 'w--current' : ''}`}
                  tabIndex={-1}
                  id="w-tabs-0-data-w-tab-4"
                  to="#w-tabs-0-data-w-pane-4"
                  role="tab"
                  aria-controls="w-tabs-0-data-w-pane-4"
                  aria-selected={activeTab === 'Resume'}
                  onClick={() => setActiveTab('Resume')}
                >
                  <div className="prof_menu no-hover">Resume</div>
                </NavLink>

                <NavLink
                  data-w-tab="Tab 6"
                  className={`public-profile-inner-tabs-menu-link w-inline-block w-tab-link ${activeTab === 'Media' ? 'w--current' : ''}`}
                  tabIndex={-1}
                  id="w-tabs-0-data-w-tab-6"
                  to="#w-tabs-0-data-w-pane-6"
                  role="tab"
                  aria-controls="w-tabs-0-data-w-pane-6"
                  aria-selected={activeTab === 'Media'}
                  onClick={() => setActiveTab('Media')}
                >
                  <div className="prof_menu no-hover">Media</div>
                </NavLink>
                </div>

                <div className="public-profile-inner-tabs-content w-tab-content">
                    <div
                        data-w-tab="Tab 1"
                        className={`public-profile-inner-tabs-content-block w-tab-pane ${activeTab === 'About' ? 'w--tab-active' : ''}`}
                        id="w-tabs-0-data-w-pane-0"
                        role="tabpanel"
                        aria-labelledby="w-tabs-0-data-w-tab-0"
                    >
                        <div className="div-block-502">
                            <div className="text-block-272 pr_t">About</div>
                            <div
                                prop-data-value-about="Experienced Data Scientist and DevOps Engineer with a demonstrated history of working in the telecommunications industry. Strong engineering professional skilled in Python, Ansible, Linux, Shell Scripting and other related technologies.#python, #ansible, #automation, #flask, #microservices, #datascientist, #linux"
                                prop-data-names="about"
                                className="text-block-298"
                                dangerouslySetInnerHTML={{__html:about}}
                            >
                            </div>
                        </div>
                    </div>
                    {activeTab === 'Experience' && <Experience username={username}
                        t={t} />}

                    {activeTab === 'Education' && <Education username={username}
                        t={t} />}

                    <div
                        data-w-tab="Tab 4"
                        className={`public-profile-inner-tabs-content-block w-tab-pane ${activeTab === 'Skills' ? 'w--tab-active' : ''}`}
                        id="w-tabs-0-data-w-pane-2"
                        role="tabpanel"
                        aria-labelledby="w-tabs-0-data-w-tab-2"
                    >

                        { activeTab === 'Skills' && (
                            <SkillsContainer
                                username={username}
                                t={t}
                            />
                        )}
                


                  

                    </div>

                    <div
                        data-w-tab="Tab 5"
                        className={`public-profile-inner-tabs-content-block w-tab-pane ${activeTab === 'Credentials' ? 'w--tab-active' : ''}`}
                        id="w-tabs-0-data-w-pane-3"
                        role="tabpanel"
                        aria-labelledby="w-tabs-0-data-w-tab-3"
                    >

                        {activeTab === 'Credentials' && (
                             <CredentialsContainer
                                username={username}
                        t={t}
                        appData={appData}
                                setAppData={setAppData}
                                />
                        )}
                    </div>

                    <div
                        data-w-tab="Tab 3"
                        className={`public-profile-inner-tabs-content-block w-tab-pane ${activeTab === 'Resume' ? 'w--tab-active' : ''}`}
                        id="w-tabs-0-data-w-pane-4"
                        role="tabpanel"
                        aria-labelledby="w-tabs-0-data-w-tab-4"
                    >
                        <div className="div-block-502">
                            {activeTab === 'Resume' && (
                                <Resume username={username} t={t} />
                            )}
                        </div>
                    </div>

                  

                    {activeTab === 'Media' && <CareerMedia username={username}  t={t} />}
                </div>
            </div>
        </>
    );
};

export default ProfileContainer;
